import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { WhitelistDialogComponent } from '@app/@shared/dialogs/whitelist/whitelist-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AdminStore } from '../admin-service/admin-service.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { UserDTO, WhitelistDTO } from '../model/users-model';

const columnsIds: string[] = ['icons', 'prescriptors'];

@Component({
  selector: 'app-whitelist',
  templateUrl: './whitelist.component.html',
  styleUrls: ['./whitelist.component.scss'],
})
export class WhitelistComponent implements OnInit {
  public entityList: CommonDataDTO[] = [];
  public entityForm: FormGroup;

  public showChainPrescriptors: boolean = false;
  public isDisabledSearchButton: boolean = true;
  public isDisabledSolutionButton: boolean = true;

  public userSelected: UserDTO;

  displayedColumns: string[] = columnsIds;
  dataSource = new MatTableDataSource<any>();

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private adminStore: AdminStore
  ) {}

  ngOnInit(): void {
    this.entityForm = this.formBuilder.group({
      entity: ['', Validators.required],
    });

    this.adminStore.loadEntities().subscribe((data: CommonDataDTO[]) => {
      this.entityList = data.sort((a, b) => (a.value > b.value ? 1 : -1));
    });

    this.entityForm.valueChanges.subscribe((value) => {
      this.showChainPrescriptors = this.entityForm.valid;
      this.isDisabledSearchButton = this.entityForm.invalid;
      let entity: WhitelistDTO = {
        entityId: value.entity,
        userId: '',
      };
      this.loadEntitiesPrescriptors(entity);
    });
  }

  public loadEntitiesPrescriptors(entity: WhitelistDTO) {
    this.adminStore.loadEntitiesPrescriptorsChain(entity).subscribe((data) => {
      this.dataSource.data = data;
    });
  }

  public onClickSearch(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = '600px';
    const dialogRef = this.dialog.open(WhitelistDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((dataDialog: any) => {
      if (dataDialog?.user) {
        this.userSelected = dataDialog.user;
        this.isDisabledSolutionButton = false;
      }
    });
  }

  public onClickCreateSolution() {
    const entitySelected = this.entityForm.controls.entity.value;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    if (this.dataSource.data.some((e) => e.userId === this.userSelected.userId)) {
      dialogConfig.data = {
        text: this.translateService.instant('whitelistDialogResponse.error').toUpperCase(),
        icon: 'icon-ic_circle_cross',
      };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    } else {
      this.adminStore
        .createSolution(this.userSelected, entitySelected)
        .then(() => {
          dialogConfig.data = {
            text: this.translateService.instant('whitelistDialogResponse.success').toUpperCase(),
            icon: 'icon-ic_circle_check',
            noRedirect: true,
          };
          let entity: WhitelistDTO = {
            entityId: entitySelected,
            userId: '',
          };
          this.loadEntitiesPrescriptors(entity);
          this.dialog.open(ResponseDialogComponent, dialogConfig);
        })
        .catch((err) => {
          dialogConfig.data = {
            text: this.translateService.instant('dialog.response.textError').toUpperCase(),
            icon: 'icon-ic_circle_cross',
            noRedirect: true,
          };
          this.dialog.open(ResponseDialogComponent, dialogConfig);
        });
    }
  }

  public onClickDelete(entityId: string, userId: string) {
    let entity: WhitelistDTO = {
      entityId: entityId,
      userId: userId,
    };

    this.adminStore.deleteFromEntity(entity).then((data: boolean) => {
      if (data) {
        entity.userId = '';
        this.loadEntitiesPrescriptors(entity);
      }
    });
  }

  public hasAnyOperation(): boolean {
    return this.dataSource.data.length > 0;
  }

  public isUserSelectedInTable(): boolean {
    return !this.dataSource.data.find((user) => user === this.userSelected);
  }
}
